import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
export class UsedRegisterCode extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.creditValue = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], UsedRegisterCode.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UsedRegisterCode.prototype, "organizationName", void 0);
__decorate([
    field({ decoder: DateDecoder })
], UsedRegisterCode.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], UsedRegisterCode.prototype, "creditValue", void 0);
export class RegisterCodeStatus extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.usedCodes = [];
        this.value = 0;
        this.invoiceValue = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], RegisterCodeStatus.prototype, "code", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(UsedRegisterCode) })
], RegisterCodeStatus.prototype, "usedCodes", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 231 })
], RegisterCodeStatus.prototype, "value", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true, version: 231 })
], RegisterCodeStatus.prototype, "invoiceValue", void 0);
export class RegisterCode extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.customMessage = null;
        this.value = 0;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], RegisterCode.prototype, "code", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegisterCode.prototype, "description", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], RegisterCode.prototype, "customMessage", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], RegisterCode.prototype, "organizationName", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], RegisterCode.prototype, "value", void 0);
//# sourceMappingURL=RegisterCodeStatus.js.map